import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './file-list-filter-topic.component.scss';
var FileListFilterTopic = /** @class */ (function (_super) {
    tslib_1.__extends(FileListFilterTopic, _super);
    function FileListFilterTopic(element) {
        return _super.call(this, element) || this;
    }
    FileListFilterTopic.prototype.init = function () {
    };
    FileListFilterTopic.prototype.bindEvents = function () {
    };
    return FileListFilterTopic;
}(Base));
export { FileListFilterTopic };



//////////////////
// WEBPACK FOOTER
// ./components/file-list-filter-topic/file-list-filter-topic.component.ts
// module id = 285
// module chunks = 0